import { Button, Dropdown, Tag } from 'antd';
import { PlusOutlined, EllipsisOutlined, CloudUploadOutlined, GlobalOutlined } from "@ant-design/icons";
import React from 'react';
import styled from 'styled-components';
import { PlanetMosaicItem } from '~/common/typescript/apis/RemoteImageAlertAPIs';

export type PlanetItemProps = {
  item: PlanetMosaicItem;
  onAddToLeft: (item: PlanetMosaicItem) => void;
  onAddToRight: (item: PlanetMosaicItem) => void;
  onViewOnQGIS: (item: PlanetMosaicItem) => void;
};

const PlanetItem: React.FC<PlanetItemProps> = ({ item, onAddToLeft, onAddToRight, onViewOnQGIS }) => {
  const title = item.title_vi || item.title;
  const subTitle = item.description || `Planet Mosaic Năm ${item.year}`;

  // Dropdown menu items
  const menuItems = [
    {
      key: 'add-right',
      label: 'Thêm vào bản đồ phải',
      icon: <PlusOutlined />,
      onClick: () => onAddToRight(item),
    },
    {
      key: 'add-left',
      label: 'Thêm vào bản đồ trái (để so sánh)',
      icon: <PlusOutlined />,
      onClick: () => onAddToLeft(item),
    },
    {
      key: 'qgis',
      label: 'Thêm vào QGIS',
      icon: <CloudUploadOutlined />,
      onClick: () => onViewOnQGIS(item),
    },
  ];

  return (
    <UI_Item_Wrapper>
      <UI_Header>
        <UI_TitleContainer>
          <UI_Name title={title}>{title}</UI_Name>
          <UI_Sub>{subTitle}</UI_Sub>
        </UI_TitleContainer>
        <Dropdown 
          menu={{ items: menuItems }} 
          trigger={['click']}
        >
          <Button 
            type="text" 
            icon={<EllipsisOutlined />} 
            size="small"
            onClick={(e) => e.preventDefault()}
          />
        </Dropdown>
      </UI_Header>

      <UI_ImageContainer onClick={() => onAddToRight(item)} title="Nhấp để thêm vào bản đồ phải">
        <UI_ImagePlaceholder>
          <GlobalOutlined style={{ fontSize: 44, color: '#1890ff' }} />
          <UI_ImageLabel>Planet NICFI</UI_ImageLabel>
        </UI_ImagePlaceholder>
        <UI_TagOverlay>
          <Tag color="#1677ff" style={{ margin: 0, fontSize: 10, lineHeight: '18px' }}>Planet</Tag>
          <Tag color="#52c41a" style={{ margin: 0, fontSize: 10, lineHeight: '18px' }}>{item.year}</Tag>
          <Tag color="#722ed1" style={{ margin: 0, fontSize: 10, lineHeight: '18px' }}>4.77m</Tag>
        </UI_TagOverlay>
      </UI_ImageContainer>

      <UI_Footer>
        <Button size="small" type="primary" ghost onClick={() => onAddToLeft(item)}>
          + Trái
        </Button>
        <Button size="small" type="primary" onClick={() => onAddToRight(item)}>
          + Phải
        </Button>
      </UI_Footer>
    </UI_Item_Wrapper>
  );
};

export default PlanetItem;

const UI_Item_Wrapper = styled.div`
  width: 250px;
  height: 270px;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  padding: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: #1677ff;
    box-shadow: 0 4px 12px rgba(22, 119, 255, 0.12);
  }
`;

const UI_Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
`;

const UI_TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  margin-right: 6px;
`;

const UI_Name = styled.div`
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1f1f1f;
`;

const UI_Sub = styled.div`
  font-size: 11px;
  color: #8c8c8c;
  margin-top: 2px;
`;

const UI_ImageContainer = styled.div`
  position: relative;
  flex: 1;
  margin: 4px 0;
  border-radius: 6px;
  overflow: hidden;
  background: #f0f2f5;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  &:hover .planet-icon {
    transform: scale(1.05);
  }
`;

const UI_ImagePlaceholder = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc;
  border-radius: 4px;
`;

const UI_ImageLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #1890ff;
  margin-top: 6px;
`;

const UI_TagOverlay = styled.div`
  position: absolute;
  top: 6px;
  left: 6px;
  display: flex;
  gap: 4px;
`;

const UI_Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
`;